import { useEffect, useState } from "react";
import useSubscribersOnlyOption from "components/Pages/Home/Helpers/useSubOnlyNotification";
import useAvoidFirstMount from "hooks/useMountedState";
import Icon from "components/Elements/Icon/Icon";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import { Toggle } from "components/Elements/Toggle/Toggle";
import { useCustomController } from "../useCustomController";
import { useContent } from "contexts/contentContext/contentContext";
import { setBodyValue } from "components/Pages/Home/UploadForms/formsFields";
import { useUploader } from "contexts/uploaderContext/uploaderContext";
import { useUser } from "contexts/userContext/userContext";

interface IDisplayVideoField {
  getValues: () => any;
}

const DisplayVideoField = ({ ...props }: IDisplayVideoField) => {
  const { fieldControls, hasError } = useCustomController(props);
  const [toggleStatus, setToggleStatus] = useState(fieldControls.value);
  const { getTextByKey, getHtmlByKey } = useContent();
  const { getIsVideodurationExceeded, getTooManyVideos } = useUploader();
  const { isLoggedIn, isSubscribed } = useUser();

  useEffect(() => {
    fieldControls.onChange(toggleStatus);
    // setting the value in the body after changing the toggle status
    setBodyValue(props, toggleStatus);
  }, [toggleStatus]);

  const { SubOnlyNotification, handleSetStatus } = useSubscribersOnlyOption({
    callbackFunc: setToggleStatus,
    subcribersOnly: true,
    titleKey: "display-video-text",
  });

  // handle disable option in case this field depends on another field value
  const [disable, setDisable] = useState("");

  useEffect(() => {
    if (!isLoggedIn()) {
      setDisable("");
      setToggleStatus(false);
    } else if (!isSubscribed()) {
      setDisable("");
    } else if (getTooManyVideos()) {
      setDisable("toomany-videos");
    } else if (props.getValues().PaymentAmount > 0) {
      setDisable("jumbopay");
    } else if (getIsVideodurationExceeded()) {
      setDisable("videoduration");
    } else {
      setDisable("");
    }
  }, [
    props.getValues().PaymentAmount,
    getIsVideodurationExceeded(),
    isLoggedIn(),
  ]);

  // changing the toggle status in case the disable option changing
  useAvoidFirstMount({
    callback: () => {
      if (disable) {
        setToggleStatus(false);
      }
    },
    dependencies: [disable],
  });

  return (
    <>
      <div className={`security-option${disable ? " disabled-field" : ""}`}>
        <Icon name="video" gray iconClass="security-option-icon" />
        <div className="security-option-text">
          {getTextByKey("display-video-text")}
        </div>
        {disable ? (
          // @ts-ignore
          <Tooltip
            tooltipText={getHtmlByKey(`video-disabled-for-${disable}`)}
            clickable
          >
            <Icon name="i" gray />
          </Tooltip>
        ) : null}
        <div className="flex-spacer" />
        <SubOnlyNotification />
        <Toggle status={toggleStatus} setStatus={handleSetStatus} />
      </div>
    </>
  );
};

export default DisplayVideoField;
